import React from 'react';
import * as _ from 'lodash';

//utilities
import { messageUtility } from '../../utilities/messageUtility';
// modals
import { Information } from '../modals/common';
// icon
import { ErrorTriangleIcon } from '../icons/ErrorTriangleIcon';

export function DirectCommunicationErrorModal({
  visible,
  setVisible,
  errorMessage,
  closeAction = () => {},
}) {
  return (
    <Information
      visible={visible}
      title={
        <React.Fragment>
          <ErrorTriangleIcon />
          エラー
        </React.Fragment>
      }
      message={
        _.isString(errorMessage)
          ? errorMessage
          : messageUtility.getMessage('E-001-402')
      }
      buttonText={messageUtility.getMessage('I-000-017')}
      onClose={() => {
        _.isFunction(closeAction) ? closeAction() : null;
        setVisible(false);
      }}
      flexMessage={true}
      tabFocus={true}
      rootClassName={'DirectDescriptionModal--DirectCommunicationError'}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/DirectCommunicationErrorModal.jsx